export interface CityFilters {
    q?: string;
    cityscapes?: string[];
    climates?: string[];
    landscapes?: string[];
    tags?: string[];
}

export const defaultCityFilters: CityFilters = {
    q: '',
    cityscapes: [],
    climates: [],
    landscapes: [],
    tags: []
};